import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

import LoginInformationModal from 'app/domains/common/Modals/LoginInformationModal'
import CheckEmailSpamIcon from 'app/components/SVGS/CheckEmailSpamIcon'
import BigVariant from './pages/big'
import SmallVariant from './pages/small'

import './styles.scss'
export const bc = 'selection-page'
class Start extends Component {
  hideFreshWidgetCustomImage = () => {
    // freshWidgetCollection is HTMLCollection, must be one on the page
    const freshWidgetCollection = document.getElementsByClassName('freshwidget-customimage')
    if (freshWidgetCollection && freshWidgetCollection.length) {
      freshWidgetCollection.item(0).style.display = 'none'
    }
  }

  componentDidUpdate() {
    const { showModal } = this.props
    const { isShowLoginInformationModal } = this.props
    this.hideFreshWidgetCustomImage()
    if (isShowLoginInformationModal) {
      showModal(
        <LoginInformationModal
          title="Don’t see your invite email? "
          text="Check Spam – it might have gone there, right next to that message from your long lost uncle with all that inheritance money."
          icon={<CheckEmailSpamIcon />}
          clearAuthStatuses={() => {}}
          withoutCross
        />,
        {
          size: 'xs',
          onRequestClose: () => {},
        }
      )
    }
  }

  componentDidMount() {
    this.props.closeShowLoginInformationModal()
  }

  render() {
    const { isPromoPageActive, pageType } = this.props
    if (!isPromoPageActive) {
      return <Redirect from="/start" to="/login" />
    }
    return <div className={`${bc}__wrapper`}>{pageType === 1 ? <SmallVariant /> : <BigVariant />}</div>
  }
}

export default Start
